import {
  AggregationCommand,
  LooseRelationCommand,
  OrderCommand,
  QueryStringCommandOptions,
  RelationCommand,
  WhereCommand,
} from '@llws/dr-objectified-query';
import { ISearchCommandOptions } from '@llws/dynamic-router-utils';

export const mergeQueryCommands = <T extends QueryStringCommandOptions | ISearchCommandOptions>(commands: T[]) => {
  let command: QueryStringCommandOptions = {};

  commands.forEach((c) => {
    command = {
      ...(c.alias || command.alias) && { alias: c.alias || command.alias },
      ...(c.limit || command.limit) && { limit: c.limit || command.limit },
      ...(c.page || command.page) && { page: c.page || command.page },
      ...(c.select || command.select) && {
        select: [
          ...command.select ? command.select : [],
          ...c.select ? c.select : [],
        ] as string[],
      },
      ...(c.relations || command.relations) && {
        relations: [
          ...command.relations ? command.relations : [],
          ...c.relations ? c.relations : [],
        ] as RelationCommand[],
      },
      ...(c.where || command.where) && {
        where: [
          ...command.where ? command.where : [],
          ...c.where ? c.where : [],
        ] as WhereCommand[],
      },
      ...(c.looseRelations || command.looseRelations) && {
        looseRelations: [
          ...command.looseRelations ? command.looseRelations : [],
          ...c.looseRelations ? c.looseRelations : [],
        ] as LooseRelationCommand[],
      },
      ...(c.orderBy || command.orderBy) && {
        orderBy: [
          ...command.orderBy ? command.orderBy : [],
          ...c.orderBy ? c.orderBy : [],
        ] as OrderCommand[],
      },
      ...(c.aggregations || command.aggregations) && {
        aggregations: [
          ...command.aggregations ? command.aggregations : [],
          ...c.aggregations ? c.aggregations : [],
        ] as AggregationCommand[],
      },
    };
  });

  return command as T;
};
